import { schemaApi } from "../../api/schemaApi"

import { NotificationTypes, addNotification } from "./notificationActions.js"

import { deviceSchemasSignal, deviceSchemasLoadedSignal, deviceSchemasErrorSignal } from "../signals/deviceSchemaSignals"

export async function fetchDeviceSchemas(config, accessToken) {
    let print = false
    deviceSchemasLoadedSignal.value = false
    deviceSchemasSignal.value = []
    let fetchFunction
    if (config.loadLocalDeviceProfileSchema) {
        if (print) {
            console.log("Loading local device schemas instead of from database")
        }
        fetchFunction = schemaApi.fetchDeviceSchemasLocal
    }
    else {
        if (print) {
            console.log("Loading device schemas from database")
        }
        fetchFunction = schemaApi.fetchDeviceSchemas
    }
    return await fetchFunction(config, accessToken).then(
        (deviceSchemasResult) => {
            if (print) {
                console.log("Got the following device schemas result:")
                console.log(deviceSchemasResult)
            }
            deviceSchemasSignal.value = deviceSchemasResult
            deviceSchemasLoadedSignal.value = true
            return deviceSchemasSignal.value
        }
    ).catch(
        (err) => {
            addNotification("Failed to fetch device schemas: ".concat(err.message), NotificationTypes.ERROR, true)
            deviceSchemasErrorSignal.value = err.message
        }
    )
}